import { useEffect } from 'react';

/**
 * Кастомный хук useEffect - подписывает/отписывает события клика
 *
 * @function
 * @name hooks.useClickOutside
 * @returns {void}
 */
export function useClickOutside(isHidden: boolean, hideHandler: (ev: PointerEvent) => void): void {
    return useEffect(() => {
        if (!isHidden) {
            // options = true необходимо для срабытвания клика раньше SyntheticEvent
            document.addEventListener('pointerdown', hideHandler, true);
        }
        return () => document.removeEventListener('pointerdown', hideHandler, true);
    }, [hideHandler, isHidden]);
}

